import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "edit-form" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.CUSTOMER,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['CUST_UPDATE'] && !_ctx.loading]
        ]),
        (_ctx.customerModel && _ctx.contactModel && _ctx.hasPermission['CUST_UPDATE'])
          ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
              key: 0,
              breadcrumbs: [['Mandanten', '/customer'], [_ctx.customerModel.name, '/customer/'+_ctx.customerModel.customerid], ['Ansprechpartner', '/customer/'+_ctx.customerModel.customerid], [_ctx.contactModel.name]]
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        (_ctx.hasPermission['CUST_UPDATE'])
          ? (_openBlock(), _createBlock(_component_el_container, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, { class: "rounded-content" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_form, {
                        ref: "editContactForm",
                        rules: _ctx.contactModel.contacttypeid == 1 ? _ctx.rulesContact1 : _ctx.contactModel.contacttypeid == 2 ? _ctx.rulesContact2 : _ctx.rulesContact3,
                        "label-position": "top",
                        model: _ctx.contactModel,
                        labelWidth: "120px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, {
                            label: "Bezeichnung",
                            prop: "name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.contactModel.name,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.contactModel.name) = $event)),
                                onInput: _ctx.onContactInput
                              }, null, 8, ["modelValue", "onInput"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Art des Ansprechpartners",
                            prop: "contacttypeid",
                            placeholder: "Bitte wählen..."
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.contactModel.contacttypeid,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.contactModel.contacttypeid) = $event)),
                                onChange: _ctx.onContactInput
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    key: "0",
                                    label: "Bitte wählen...",
                                    value: 0
                                  }),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactTypeModelList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.contacttypeid,
                                      label: item.name,
                                      value: item.contacttypeid
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Anrede",
                            prop: "salutation"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.contactModel.salutation,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.contactModel.salutation) = $event)),
                                onInput: _ctx.onContactInput
                              }, null, 8, ["modelValue", "onInput"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Abteilung innerhalb der Organisation",
                            prop: "department"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.contactModel.department,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.contactModel.department) = $event)),
                                onInput: _ctx.onContactInput
                              }, null, 8, ["modelValue", "onInput"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Vorname",
                            prop: "firstname"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.contactModel.firstname,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.contactModel.firstname) = $event)),
                                onInput: _ctx.onContactInput
                              }, null, 8, ["modelValue", "onInput"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Nachname",
                            prop: "lastname"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.contactModel.lastname,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.contactModel.lastname) = $event)),
                                onInput: _ctx.onContactInput
                              }, null, 8, ["modelValue", "onInput"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "E-Mail",
                            prop: "email"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.contactModel.email,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.contactModel.email) = $event)),
                                onInput: _ctx.onContactInput
                              }, null, 8, ["modelValue", "onInput"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Telefon (Festnetz)",
                            prop: "phone"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.contactModel.phone,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.contactModel.phone) = $event)),
                                onInput: _ctx.onContactInput
                              }, null, 8, ["modelValue", "onInput"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "Mobiltelefon",
                            prop: "mobile"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.contactModel.mobile,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.contactModel.mobile) = $event)),
                                onInput: _ctx.onContactInput
                              }, null, 8, ["modelValue", "onInput"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                disabled: !_ctx.formContactValid,
                                onClick: _ctx.onContactSaveClick
                              }, {
                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                  _createTextVNode(" Speichern ")
                                ])),
                                _: 1
                              }, 8, ["disabled", "onClick"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["rules", "model"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}